import { Countries } from '../models/countries'

export default (govid, country) => {
  if (country === Countries.SE) {
    const seGovId = govid.replace('-', '')
    return `${seGovId.substring(0, seGovId.length - 4)}-${seGovId.substring(
      seGovId.length - 4,
    )}`
  }

  return govid
}
